import React from 'react';
import { SkipLink } from '@hvcgroep/design-system';
import Navbar from '../Navbar';

import './style.scss';
import useAuth from '../../hooks/useAuth';

interface Props {
  children?: React.ReactNode;
}

const Page: React.FC<Props> = ({
  children,
}) => {
  const { state: authState } = useAuth();

  return (
    <div className="mo-page">
      {authState === 'Authorized' && (
        <>
          <div className="container-fluid">
            <SkipLink />
          </div>
          <Navbar />
        </>
      ) }
      <main className="main-container" id="main-content">
        {children}
      </main>
    </div>
  );
};

export default Page;
